import { useMutationInfo } from 'client/shared/containers/mutation';
import { adminAiAssistantCreateSession } from 'client/shared/graphql-mutations/mutation-infos';
import { AiAssistant } from 'core';
import { AssistantType } from 'graphql-schema/schema-types.g';

export function useCreateAiAssistantSession() {
  const { fn, result } = useMutationInfo(adminAiAssistantCreateSession);

  return {
    createSession: async (args: {
      sessionId: string;
      assistant: AiAssistant;
      sessionIdToResume?: string;
    }) => {
      const res = await fn({
        variables: {
          sessionId: args.sessionId,
          assistant: {
            type: args.assistant.type as AssistantType,
            id: args.assistant.id,
          },
          sessionIdToResume: args.sessionIdToResume,
        },
      });

      return res.data?.adminAiAssistantCreateSession;
    },

    loading: result.loading,
    error: result.error,
  };
}
